import { render } from "./AmListPage.vue?vue&type=template&id=9b600c92&scoped=true"
import script from "./AmListPage.vue?vue&type=script&lang=js"
export * from "./AmListPage.vue?vue&type=script&lang=js"

import "./AmListPage.vue?vue&type=style&index=0&id=9b600c92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b600c92"]])

export default __exports__